<template>
    <b-modal
        ref="modalDeletePatientNote"
        title-tag="h2"
        title="Delete Note"
        lazy
    >
        Are you sure you want to permanently delete this record?
        <template v-slot:modal-footer="{ cancel, close }">
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                v-if="!isLoading"
                @click="cancel()"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isLoading"
                variant="primary"
                @click="deleteNote(close)"
            >
                Proceed
            </b-button>
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import Notes from "@/services/patient-notes";
import Loader from "@/components/elements/loader";

export default {
    components: {
        Loader
    },
    props: {
        patientId: {
            type: String
        }
    },
    data() {
        return {
            isLoading: false,
            noteId: null
        };
    },
    methods: {
        open(noteId) {
            this.noteId = noteId;
            this.$refs.modalDeletePatientNote.show();
        },
        deleteNote(closeFn) {
            if (this.noteId == null) {
                return false;
            }

            this.isLoading = true;
            Notes.deleteNote(this.noteId)
                .then(() => {
                    this._message("Note deleted");
                    this.$emit("reload");
                    this.$store.dispatch(
                        "patient/loadPopupNotes",
                        this.patientId
                    );
                    closeFn();
                })
                .catch(error => {
                    this._message("Error : Unable to delete note", "danger");
                    console.error(error);
                });
        }
    }
};
</script>
